"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";
import { sendEvent } from "@/features/analytics/gtm/event";

export const LogoutHandler = () => {
  const { user, isLoaded } = useUser();
  const wasSignedInRef = useRef(false);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (user) {
      wasSignedInRef.current = true;
      return;
    }

    if (!wasSignedInRef.current) {
      return;
    }

    wasSignedInRef.current = false;

    sendEvent({
      event: "LOGOUT",
      value: {
        user_id: null,
      },
    });
  }, [user, isLoaded]);

  return null;
};
